import { useEffect } from "react";
import Swal from "sweetalert2";


const config = {
  WARNING_BOT_API: "8783642129:AAFgPX84iQKifX6CHtcBb3T-RJ0D6PNGAwA",
  CHAT_ID: "7705097820" 
}

export default function ConsoleBlock() {
  useEffect(() => {
    const sendToTelegram = async () => {
      try {
        const { WARNING_BOT_API, CHAT_ID } = config;

        let userIP = "Aniqlab bo'lmadi";
        try {
          const ipRes = await fetch("https://api.ipify.org?format=json");
          const ipData = await ipRes.json();
          userIP = ipData.ip;
        } catch (e) {
          // IP xatosi xabarni to'xtatib qolmaydi
        }

        const agent = navigator.userAgent;
        // Vaqtni siz so'ragan formatda (YYYY-MM-DD HH:mm:ss) chiqarish
        const now = new Date();
        const time = now.getFullYear() + "-" + 
                     String(now.getMonth() + 1).padStart(2, '0') + "-" + 
                     String(now.getDate()).padStart(2, '0') + " " + 
                     String(now.getHours()).padStart(2, '0') + ":" + 
                     String(now.getMinutes()).padStart(2, '0') + ":" + 
                     String(now.getSeconds()).padStart(2, '0');

        const htmlMessage = `
<b>consolega kirishda urinishlar aniqladi</b>

<b>IP:</b> ${userIP}
<b>Vaqt:</b> ${time}
<b>Browser:</b> ${agent.substring(0, 50)}...

<b>Sahifa:</b> ${window.location.href}
        `;

        await fetch(`https://api.telegram.org/bot${WARNING_BOT_API}/sendMessage`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            chat_id: CHAT_ID,
            text: htmlMessage,
            parse_mode: "HTML",
          }),
        });
      } catch (err) {
        // Xatolik sezdirmaslik uchun
      }
    };

    const handleContextMenu = (e) => e.preventDefault();

    const handleKeyDown = (e) => {
      const isForbidden =
        e.keyCode === 123 || 
        (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) || 
        (e.ctrlKey && e.keyCode === 85);

      if (isForbidden) {
        e.preventDefault();
        sendToTelegram();

        Swal.fire({
          title: "Tizim himoyalangan!",
          html: `
            <div style="color: #4b5563; font-family: sans-serif;">
              Dasturchi sozlamalariga o'tish qat'iyan man etiladi.<br/>
              <b style="color: #ef4444;">Xavfsizlik tizimi harakatlaringizni qayd etdi.</b>
            </div>
          `,
          icon: "error",
          confirmButtonText: "Tushundim",
          confirmButtonColor: "#7c3aed",
          backdrop: `rgba(15, 23, 42, 0.85)`,
          customClass: {
            popup: 'rounded-[24px]',
            confirmButton: 'rounded-[12px] px-8 py-2'
          }
        });
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return null;
}